/*
 * Copyright ish group pty ltd 2022.
 *
 * This program is free software: you can redistribute it and/or modify it under the terms of the GNU Affero General Public License version 3 as published by the Free Software Foundation.
 *
 *  This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more details.
 */

export const LS_TIMETABLE_TAGS_MODE = "lsTimetableTagsMode";

export const LS_TIMETABLE_CALENDAR_MODE = "lsTimetableCalendarMode";

export const LS_TIMETABLE_GROUPING_MODE = "lsTimetableGroupingMode";

export const NO_TUTORS_LABEL = "No tutor set";

export const NO_ROOM_LABEL = "No room set";